import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-company-info-co-so-nuoi-detail',
  templateUrl: './company-info-co-so-nuoi-detail.component.html',
  styleUrls: ['./company-info-co-so-nuoi-detail.component.css']
})
export class CompanyInfoCoSoNuoiDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
